<script setup lang="ts"></script>
<template>
  <div class="slide-headline font-montserrat text-clockin-text">
    <slot />
  </div>
</template>
<style scoped>
  .slide-headline {
    height: 10%;
    margin: 0;
    margin-bottom: 16px;
    font-size: 24px;
    text-align: center;
    font-weight: 700;
    color: #333;
  }
</style>
